const trolleyQuantityValidation = {
    INVALID_QUANTITY: 'InvalidQuantity',
    SUPPLY_LIMIT_EXCEEDED: 'QtyIsGreater',
    DELIVERY_PASS_LIMIT_EXCEEDED: 'DeliveryPassLimit',
};

module.exports = { trolleyQuantityValidation };



// WEBPACK FOOTER //
// ./src/shop/trolley/trolley-quantity-validation.constant.js